export default {
  countryOfIssue: {
    id: 'bo_seller_profile_page_tin_block_country_issue',
    defaultMessage: 'Country of issue',
  },
  taxIdentificationNumber: {
    id: 'bo_seller_profile_page_tin_label',
    defaultMessage: 'Tax Identification Number (TIN)',
  },
  taxIdentificationNumberLabel: {
    id: 'bo_seller_profile_page_modal_tin_label',
    defaultMessage: 'Tax identification number',
  },
  description: {
    id: 'bo_seller_profile_page_tin_block_description',
    defaultMessage:
      "Add your business' Tax Identification Number (TIN). We'll use this information for tax and legal purposes",
  },
  mainLocation: {
    id: 'bo_seller_profile_page_tin_block_main_location',
    defaultMessage: 'Main location',
  },
  helpLinkUrl: {
    id: 'bo_seller_profile_page_tin_block_link_url',
    defaultMessage:
      'https://backmarket.my.site.com/ssc/s/article/Whats-the-DAC7-directive#WherecanIfindmyTaxIdentificationNumber',
  },
  submitButton: {
    id: 'bo_seller_profile_page_tin_modal_submit_button',
    defaultMessage: 'Add TIN',
  },
  cancelButton: {
    id: 'bo_seller_profile_page_tin_modal_cancel_button',
    defaultMessage: 'Cancel',
  },
  helpLinkText: {
    id: 'bo_seller_profile_page_tin_block_link_text',
    defaultMessage: 'Read more about it here',
  },
  countryRequired: {
    id: 'bo_seller_profile_page_tin_modal_country_required',
    defaultMessage: 'Please select a country.',
  },
  taxIdentificationNumberRequired: {
    id: 'bo_seller_profile_page_tin_modal_tin_required',
    defaultMessage: 'Please enter a TIN.',
  },
  toDoLabel: {
    id: 'bo_seller_profile_page_tin_block_todo',
    defaultMessage: 'To do',
  },
  taxIdentificationNumberCountryLabel: {
    id: 'bo_seller_profile_page_tin_block_country_select_label',
    defaultMessage: 'Country of issue ',
  },
  addTinModalTitle: {
    id: 'bo_seller_profile_page_tin_modal_add_title',
    defaultMessage: 'Add TIN',
  },
  addNewTinButtonLabel: {
    id: 'bo_seller_profile_page_tin_block_add_new_number',
    defaultMessage: 'Add new number',
  },
  addTinButtonLabel: {
    id: 'bo_seller_profile_page_tin_block_add_number',
    defaultMessage: 'Add number',
  },
  editTinModalTitle: {
    id: 'bo_seller_profile_page_tin_block_modal_edit_title',
    defaultMessage: 'Edit TIN',
  },
  loadingEditTinModalTitle: {
    id: 'bo_seller_profile_page_tin_block_modal_edit_loading_text',
    defaultMessage: 'Updating your TIN...',
  },
  loadingAddTinModalTitle: {
    id: 'bo_seller_profile_page_tin_block_modal_add_loading_text',
    defaultMessage: 'Adding your TIN...',
  },
  taxIdentificationNumberDeleteSuccessTitle: {
    id: 'bo_seller_profile_page_tin_block_delete_success_title',
    defaultMessage: 'TIN deleted ✔️',
  },
  taxIdentificationNumberUpdateSuccessTitle: {
    id: 'bo_seller_profile_page_tin_modal_update_success_title',
    defaultMessage: 'TIN updated ✔️',
  },
  taxIdentificationNumberCreateSuccessTitle: {
    id: 'bo_seller_profile_page_tin_modal_update_success_title',
    defaultMessage: 'TIN added ✔️',
  },
  taxIdentificationNumberModalSuccessContent: {
    id: 'bo_seller_profile_page_tin_modal_success_content',
    defaultMessage: 'Nice work.',
  },
  taxIdentificationNumberDeleteSuccessContent: {
    id: 'bo_seller_profile_page_tin_block_todo_delete_success_title',
    defaultMessage: 'Nice work.',
  },
  deleteTinButton: {
    id: 'bo_seller_profile_page_tin_block_delete_tin_button',
    defaultMessage: 'Delete TIN',
  },
}
